import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import StatusBoardPage from "pages/dashboard/facility/StatusBoardPage";
import WaitingRoom from "components/queue/WaitingRoom";
import SchedulerPage from "pages/dashboard/facility/SchedulerPage";
import VirtualRegistrationPage from "pages/dashboard/facility/VirtualRegistrationPage";
import Settings from "components/dashboard/Settings";
import AuctionPage from "pages/dashboard/AuctionPage";
import UpgradePage from "pages/dashboard/UpgradePage";
import Approval from "components/dashboard/admin/Approval";
import AssistantManager from "components/dashboard/admin/AssistantManager";
import UsageMonitor from "components/dashboard/admin/UsageMonitor";
import { useFacility } from "hooks/useFacility";
import { useAuth } from "hooks/useAuth";
import QueueDisplay from "components/queue/splitflap/QueueDisplay";
import DashboardLayout from "components/dashboard/DashboardLayout";
import FacilityOnboardingDialog from "components/dashboard/FacilityOnboardingDialog";
import FacilityChecklist from "components/dashboard/FacilityChecklist";
import { db } from "services/firebase";

const DashboardRoutes = () => {
  const { data, setData } = useFacility();
  const { user, subscription } = useAuth();
  const location = useLocation();
  const isBoard = location.pathname === "/dashboard/queue/board";
  const [showFacilityOnboarding, setShowFacilityOnboarding] = useState(false);

  useEffect(() => {
    // Check if we should show the onboarding dialog
    const checkOnboardingStatus = async () => {
      if (user?.uid) {
        try {
          const userDoc = await db.collection("users").doc(user.uid).get();
          const userData = userDoc.data();

          if (
            userData?.role === "facility" &&
            !userData?.hideFacilityOnboardingDialog
          ) {
            setShowFacilityOnboarding(true);
          }
        } catch (error) {
          console.error("Error checking onboarding status:", error);
        }
      }
    };

    checkOnboardingStatus();
  }, [user]);

  const handleCloseFacilityOnboarding = () => {
    setShowFacilityOnboarding(false);
  };

  return (
    <DashboardLayout fullWidth={isBoard}>
      {/* Checklist manages its own visibility based on auth state */}
      {!isBoard && <FacilityChecklist locationData={data} />}

      <FacilityOnboardingDialog
        open={showFacilityOnboarding}
        onClose={handleCloseFacilityOnboarding}
        userId={user?.uid}
        locationData={data}
      />
      <Routes>
        <Route exact path="/" element={<StatusBoardPage data={data} />} />
        <Route
          path="/queue/board"
          element={<QueueDisplay queue={data.queue} />}
        />

        <Route
          path="/virtual-registration"
          element={<VirtualRegistrationPage data={data} setData={setData} />}
        />
        <Route
          path="/queue"
          element={<WaitingRoom data={data} setData={setData} />}
        />
        <Route
          path="/schedule"
          element={<SchedulerPage data={data} setData={setData} />}
        />
        <Route
          path="/settings"
          element={<Settings uid={user.uid} subscription={subscription} />}
        />

        <Route path="/upgrade" element={<UpgradePage />} />
        <Route path="/admin/approval" element={<Approval />} />
        <Route path="/admin/assistants" element={<AssistantManager />} />
        <Route path="/admin/usage" element={<UsageMonitor />} />
        <Route path="/advertising" element={<AuctionPage />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardRoutes;
